module.exports = __webpack_public_path__ + "img/Logo-MEL-BHP-primary.e28f5768.png";